import React, { useState } from "react";

const SearchBar = ({ placeholder, onSearch }) => {
    const [query, setQuery] = useState("");
    const inputRef = React.useRef(null);

    const submit = () => {
      // Read directly from DOM so programmatic fills are always caught
      const val = inputRef.current ? inputRef.current.value : query;
      if (val.trim()) onSearch(val.trim());
    };

    return (
    <div style={styles.searchContainer}>
        <input
        ref={inputRef}
        type="text"
        placeholder={placeholder || "Search..."}
        style={styles.input}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") submit(); }}
        />
        <button style={styles.button} onClick={submit}>
        🔍
        </button>
        <style>{`
          input::placeholder { color: rgba(255,255,255,0.5); }
        `}</style>
    </div>
    );
};

const styles = {
  searchContainer: {
    display: "flex",
    alignItems: "center",
    border: "1px solid rgba(255,255,255,0.25)",
    borderRadius: "999px",
    padding: "8px 16px",
    width: "600px",
    margin: "10px auto",
    background: "rgba(255,255,255,0.12)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
  },
  input: {
    flex: 1,
    border: "none",
    outline: "none",
    padding: "4px 8px",
    fontSize: "15px",
    background: "transparent",
    color: "white",
  },
  button: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    fontSize: "18px",
    color: "rgba(255,255,255,0.7)",
    display: "flex",
    alignItems: "center",
  },
};

export default SearchBar;